import type {
  ContentReactionCounts,
  ContentReactionType,
} from "@circle-react/types/ContentReaction";

export const resolveAllReactionsCount = ({
  allReactionsCount,
  selectedReaction,
  totalCount,
}: {
  allReactionsCount: number;
  selectedReaction: ContentReactionType | null;
  totalCount?: number;
}) =>
  selectedReaction === null
    ? (totalCount ?? allReactionsCount)
    : allReactionsCount;

export const updateReactionCounts = ({
  counts,
  previousReaction,
  nextReaction,
}: {
  nextReaction: ContentReactionType | null;
  previousReaction: ContentReactionType | null;
  counts: ContentReactionCounts;
}) => {
  const nextCounts = { ...counts };

  if (previousReaction) {
    nextCounts[previousReaction] = Math.max(
      nextCounts[previousReaction] - 1,
      0,
    );
  }
  if (nextReaction) {
    nextCounts[nextReaction] += 1;
  }

  return nextCounts;
};
